import { math } from "@engine";
import type { Shape } from "../level/types";

export interface ShapeConfig {
  shape: Shape;
  sides: number;
  radius: number;
  snapAngle: number;
  primary: number;
  accent: number;
  emissive: number;
  textureKey?: string;
}

export const SHAPES: Record<Shape, ShapeConfig> = {
  octagon: {
    shape: "octagon",
    sides: 8,
    radius: 4.5,
    snapAngle: math.TAU / 8,
    primary: 0x2bd3ff,
    accent: 0x0a4f6c,
    emissive: 0x114b66,
    textureKey: "tex.wall.octagon",
  },
  square: {
    shape: "square",
    sides: 4,
    radius: 3.6,
    snapAngle: math.TAU / 4,
    primary: 0xffd23f,
    accent: 0x6c4f0a,
    emissive: 0x664a14,
    textureKey: "tex.wall.square",
  },
  triangle: {
    shape: "triangle",
    sides: 3,
    radius: 3.2,
    snapAngle: math.TAU / 3,
    primary: 0xff5cb1,
    accent: 0x6c0a4f,
    emissive: 0x661454,
    textureKey: "tex.wall.triangle",
  },
  // Pentagon -- "magenta" theme accent. Sits between square and
  // hexagon in difficulty: 5 walls means 1 gap is more punishing
  // because there are fewer "safe" landing panels left over.
  pentagon: {
    shape: "pentagon",
    sides: 5,
    radius: 3.8,
    snapAngle: math.TAU / 5,
    primary: 0xff66dd,
    accent: 0x4a0a3a,
    emissive: 0x4a1444,
  },
  // Hexagon -- "forest" theme accent. Honeycomb feel; 6 panels gives
  // generous gap/floor balance which makes it the friendliest of the
  // odd-shape introductions.
  hexagon: {
    shape: "hexagon",
    sides: 6,
    radius: 4.2,
    snapAngle: math.TAU / 6,
    primary: 0x6bff9c,
    accent: 0x0a4f2c,
    emissive: 0x144a2c,
  },
};

export function shapeOf(shape: Shape): ShapeConfig {
  return SHAPES[shape];
}
